export async function updateDetailOrderReturnedUseCase(order, orderReturnedRepository) {
    const detail_order_return = new orderReturnedRepository.model(order);
  
    const is_valid = detail_order_return.isValid();

    if (is_valid != true) {
      throw new Error(is_valid);
    }
  
    return orderReturnedRepository.update_detail_order_returned(detail_order_return);
}